import React, { useContext } from 'react';

export type BlankCoverContext = boolean;

/**
 * Context that provides information if cover should be set to blank image
 *
 * @type {React.Context<boolean>}
 */
const Ctx = React.createContext(false);

export const BlankCoverProvider = Ctx.Provider;
export const BlankCoverConsumer = Ctx.Consumer;

export function useBlankCover(): BlankCoverContext {
    return useContext(Ctx);
}
